var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"content"},[_c('Username',{attrs:{"user":_vm.message.from}}),_vm._v(" \n\t"),_c('span',{staticClass:"ctcp-message"},[_c('ParsedMessage',{attrs:{"text":_vm.message.ctcpMessage}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }